export function isNotNullOrUndefined<T>(
  value: T | undefined | null
): value is T {
  return value !== undefined && value !== undefined;
}
